import { createStore } from '@shared/utils/state/state-factory'
import { omit } from 'lodash'
import { PubnubStatus } from 'v2/types/pubnub'

interface TabState {
  pubnubStatus: PubnubStatus
  isHydrated: boolean
  isPhoneConnected: boolean // this is a tab specific state to track if the phone is connected
}

interface Actions {
  setPubnubStatus: (status: PubnubStatus) => void
  setIsHydrated: (isHydrated: boolean) => void
  setIsPhoneConnected: (isPhoneConnected: boolean) => void
  reset: () => void
}

// State that is shared within the tab
const initialState: TabState = {
  pubnubStatus: PubnubStatus.IDLE,
  isHydrated: false,
  isPhoneConnected: false,
}

export const useTabStore = createStore<TabState & Actions>(
  'tab',
  (set) => ({
    ...initialState,
    reset: () => set(omit(initialState, 'isHydrated', 'userAuthenticated')),
    setPubnubStatus: (status) => set({ pubnubStatus: status }),
    setIsHydrated: (isHydrated) => set({ isHydrated }),
    setIsPhoneConnected: (isPhoneConnected) => set({ isPhoneConnected }),
  }),
  {
    shared: false,
    persist: false,
    onHydrate: () => () => {
      useTabStore.setState({ isHydrated: true })
    },
  },
)
